import React, { Component } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { Search as SearchIcon } from 'react-feather';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import PerPage from '../Layout/PerPage';
import AddButton from '../Layout/AddButton';

class Search extends Component {
    constructor(props){
        super(props);
        this.state = {search: ""}
    }

    reset = () => {
        const { auth, getJobs } = this.props;
        getJobs(auth.token,false);
        this.setState({search: "" });
    }

    render(){
        const { auth, getJobs, jobsMeta, toggleModal } = this.props;
        const { search } = this.state;
        return (
            <div className="mb-4">
                <Row>
                    <Col xs="12">
                        <div className="d-flex flex-wrap">
                            <div className="m-1" style={{ minWidth:"40%" }}>
                                <Input onChange={(event) => this.setState({search: event.target.value})} value={search} placeholder="Search" /> 
                            </div>
                            <div className="m-1">
                                <Button color="success" onClick={() => getJobs(auth.token, {page: 1, text_filter: search})}><SearchIcon style={{ strokeWidth: "3px", verticalAlign: "text-bottom"}} size={18}/></Button>
                            </div>
                            <div className="m-1">
                               <AddButton type="jobs"/>
                            </div>
                            <div className="m-1">
                                <Button onClick={() => toggleModal("jobs","search")} color="info">Advanced</Button>
                            </div>
                            <div className="m-1">
                                <Button color="primary" onClick={this.reset}>Reset</Button>
                            </div>
                            <div className="m-1">
                                <PerPage fetch={getJobs} meta={jobsMeta}/>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    jobsMeta: state.jobStore.jobsMeta,
});

const { jobs, modals } = Actions;

export default connect(mapStateToProps,{ ...jobs, ...modals })(Search);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/Search.js